// extracted by mini-css-extract-plugin
export default {"SideMenuItem":"SideMenuItem__SideMenuItem___HkitO","active":"SideMenuItem__active___IBS0N","SideMenuButton":"SideMenuItem__SideMenuButton___AannF"};